/**
 * Main Dashboard App Component
 * Displays all trading metrics in a comprehensive layout
 */

import { AccountOverview } from './components/AccountOverview';
import { Positions } from './components/Positions';
import { CircuitBreakers } from './components/CircuitBreakers';
import { PerformanceChart } from './components/PerformanceChart';
import { PDTStatus } from './components/PDTStatus';
import { MarketData } from './components/MarketData';
import { RecentTrades } from './components/RecentTrades';
import { TaxSummary } from './components/TaxSummary';
import { ActivityFeed } from './components/ActivityFeed';

export default function App() {
  const now = new Date();
  const marketHours = now.getHours() >= 9 && now.getHours() < 16;

  return (
    <div className="dashboard">
      {/* Header */}
      <header className="header">
        <h1>AMRTS Trading Dashboard</h1>
        <div className="header-status">
          <div className="status-indicator">
            <div className={`status-dot ${marketHours ? 'green' : 'red'}`} />
            <span>{marketHours ? 'Market Open' : 'Market Closed'}</span>
          </div>
          <div className="status-indicator">
            <div className="status-dot green" />
            <span>Live Data</span>
          </div>
          <div>
            {now.toLocaleString('en-US', {
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: true,
            })}
          </div>
        </div>
      </header>

      {/* Main Grid Layout */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
        {/* Top Row: Account Overview (full width) */}
        <AccountOverview />

        {/* Second Row: Circuit Breakers + PDT Status */}
        <div className="grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
          <CircuitBreakers />
          <PDTStatus />
        </div>

        {/* Third Row: Positions (full width) */}
        <Positions />

        {/* Fourth Row: Performance Chart + Market Data */}
        <div className="grid" style={{ gridTemplateColumns: '2fr 1fr' }}>
          <PerformanceChart />
          <MarketData />
        </div>

        {/* Fifth Row: Recent Trades + Tax Summary */}
        <div className="grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
          <RecentTrades />
          <TaxSummary />
        </div>

        {/* Sixth Row: Activity Feed (full width) */}
        <ActivityFeed />
      </div>

      {/* Footer */}
      <footer style={{ marginTop: '2rem', paddingTop: '1rem', borderTop: '1px solid var(--border-color)' }}>
        <div style={{ textAlign: 'center', fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
          AMRTS - Adaptive Mean Reversion Trading System
        </div>
        <div style={{ textAlign: 'center', fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: '0.25rem' }}>
          Built with Cloudflare Workers • Real-time data updates every 5 seconds
        </div>
      </footer>
    </div>
  );
}
